module.exports = __webpack_public_path__ + "static/media/icons-01.585c8e6d.png";